import React from "react";
import { Create, useForm } from "@refinedev/antd";
import { Form, Input, Select, DatePicker, Row, Col } from "antd";

export const AccountingPeriodsCreate = () => {
    const { formProps, saveButtonProps } = useForm();

    return (
        <Create saveButtonProps={saveButtonProps} title="Create Accounting Period">
            <Form {...formProps} layout="vertical">
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <Form.Item
                            label="Period ID"
                            name={["periodId"]}
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter period ID (YYYYMM format)",
                                },
                                {
                                    pattern: /^\d{6}$/,
                                    message: "Period ID must be in YYYYMM format",
                                },
                            ]}
                        >
                            <Input placeholder="202501" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Year"
                            name={["year"]}
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter year",
                                },
                            ]}
                        >
                            <Input type="number" placeholder="2025" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <Form.Item
                            label="Month"
                            name={["month"]}
                            rules={[
                                {
                                    required: true,
                                    message: "Please select month",
                                },
                            ]}
                        >
                            <Select placeholder="Select month">
                                <Select.Option value={1}>January</Select.Option>
                                <Select.Option value={2}>February</Select.Option>
                                <Select.Option value={3}>March</Select.Option>
                                <Select.Option value={4}>April</Select.Option>
                                <Select.Option value={5}>May</Select.Option>
                                <Select.Option value={6}>June</Select.Option>
                                <Select.Option value={7}>July</Select.Option>
                                <Select.Option value={8}>August</Select.Option>
                                <Select.Option value={9}>September</Select.Option>
                                <Select.Option value={10}>October</Select.Option>
                                <Select.Option value={11}>November</Select.Option>
                                <Select.Option value={12}>December</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Status"
                            name={["status"]}
                            rules={[
                                {
                                    required: true,
                                    message: "Please select status",
                                },
                            ]}
                        >
                            <Select placeholder="Select status">
                                <Select.Option value={0}>Open</Select.Option>
                                <Select.Option value={1}>Closed</Select.Option>
                                <Select.Option value={2}>Locked</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <Form.Item
                            label="Start Date"
                            name={["startDate"]}
                            rules={[
                                {
                                    required: true,
                                    message: "Please select start date",
                                },
                            ]}
                        >
                            <DatePicker style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="End Date"
                            name={["endDate"]}
                            rules={[
                                {
                                    required: true,
                                    message: "Please select end date",
                                },
                            ]}
                        >
                            <DatePicker style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item
                            label="Notes"
                            name={["notes"]}
                        >
                            <Input.TextArea rows={4} placeholder="Additional notes about this accounting period" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Create>
    );
};